// Dependecies
import React from 'react'

const TextArea = (props) => {
  return (
    <div className={`flex flex-col items-start w-full ${props.overrideStyles}`}>
      <label htmlFor={props.for} className='flex items-center text-black opacity-60 mb-2 font-normal'>{props.labelText} <span className='text-red-600 ml-1'>*</span></label>
      <textarea id={props.for} name={props.name} className='border border-[#161C33] rounded-sm px-3 py-1 w-full' required={props.inputRequired} placeholder={props.placeholder} defaultValue={props.value} />
    </div>
  )
}

export default TextArea